export default {
  pages: [],
  nodes: [],
  widgets: [],
  locale: 'de',
  multilanguage: false,
  languages: []
}
